import React from 'react';
import { PayRegistrationFeeStep } from '../../PayRegistrationFeeStep';

export const RegistrationFeeStep = ({ goNext }: { goNext: () => void }) => {
  return <PayRegistrationFeeStep goNext={goNext} />;
};
